import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const StatsIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M13 19H11V4.92H13V19ZM18.66 19H16.66V9.64H18.66V19ZM7.4 19H5.28V14.32H7.4V19Z" />
    </SvgIcon>
  );
});
